import StickyBookBar from "@/components/StickyBookBar";
import { useLocation } from "wouter";
import { getRouteTreatmentBookingConfig } from "@shared/bookingLinks";

const COMMERCIAL_ROUTES: Record<string, { treatmentName: string; priceHint: string }> = {
  "/membership": { treatmentName: "Lakewood Elite Membership", priceHint: "$199/month" },
  "/skin-analysis": { treatmentName: "Skin Analysis", priceHint: "Physician-guided evaluation" },
  "/ai-skin-analysis": { treatmentName: "AI Skin Analysis", priceHint: "Free analysis · Physician consultation available" },
  "/technology-comparison": { treatmentName: "Technology Consultation", priceHint: "Compare options with a physician" },
};

export default function CommercialStickyBookBar() {
  const [location] = useLocation();
  const path = location.split("?")[0];
  const routeBooking = getRouteTreatmentBookingConfig(path);
  const config = path.startsWith("/devices/")
    ? { treatmentName: "Device Consultation", priceHint: "Consultation required" }
    : COMMERCIAL_ROUTES[path];

  if (!config && !routeBooking?.injectSticky) return null;
  return <StickyBookBar treatmentName={config?.treatmentName ?? routeBooking!.treatmentName} priceHint={config?.priceHint ?? "Physician consultation available"} />;
}
